export const lang = {
    get: (string: string, parameters: string[]) => {
        switch (string) {
            case 'ITEMS_COMPLETED_DETAIL': {
                const foodCount = parameters?.[0]?.[0];
                const drinkCount = parameters?.[0]?.[1];
                const foodNames = parameters?.[1];
                const drinkNames = parameters?.[2];
                let result: string[] = [];
                if (foodCount) result.push(`Mat: ${foodNames}`);
                if (drinkCount) result.push(`Dryck: ${drinkNames}`);
                return result.filter(Boolean).join('. ');
            }
            case 'ORDER_ARRIVED_SUMMARY': {
                const orderCode = parameters?.[0];
                return `Beställning #${orderCode} har anlänt!`;
            }
            case 'TIMER_STARTED_DETAIL': {
                return `Timer startad för ${parameters[0]} minut${parameters[1]}.`;
            }
            case 'NO_ORDERS_FOR_DAY': {
                return `Inga beställningar för ${parameters?.[0] || ''}.`.trim();
            }
            case 'NO_FOOD_ORDERS_FOR_DAY': {
                return `Inga matbeställningar för ${parameters?.[0] || ''}.`.trim();
            }
            case 'NO_DRINK_ORDERS_FOR_DAY': {
                return `Inga dryckesbeställningar för ${parameters?.[0] || ''}.`.trim();
            }

            default: return '';
        }
    },
    LOADING: 'Laddar...',
    NO_ACTIVE_ORDERS_TO_SHOW: 'Inga aktiva beställningar att visa.',
    NO_DRINK_ORDERS: 'Inga dryckesbeställningar.',
    NO_FOOD_ORDERS: 'Inga matbeställningar.',
    CHECK_BACK_LATER: 'Kolla igen senare för nya beställningar.',
    ORDERED_BY: 'Beställd av',

    ALL_ORDERS: 'Alla ordrar',
    WEEKLY_ORDERS: 'Veckoordrar',
    EAT_IN: 'Äta här',
    FIXED_DELIVERY: 'Fast leverans',
    TAKEAWAY: 'Ta med',
    TABLE_SERVING: 'Bord',
    DELIVERY: 'Utkörning',
    AI_PHONE_ORDERS: 'AI-telefonorder',
    AI_PREP_TIME: 'Genomsnittlig tillagningstid just nu',
    AI_PREP_TIME_HINT: 'Det här är vad AI-telefonagenten uppger för kunden.',
    AI_PREP_TIME_UNSET: 'Inte satt — kunden hör 20–25 minuter',
    MINUTES_SHORT: 'min',
    AI_PHONE_ORDER: 'AI-telefonorder',
    CUSTOM: 'Anpassad',
    DELIVERY_PLACE: "Servering",
    COMPLETED: "Genomförda",
    ACTIVE: "Aktiva",
    SCHEDULED: "Schemalagda",
    INCOMING: "Inkommande",
    LANGUAGE: 'Språk',
    SALES_CHANNEL: 'Säljkanal',
    PHONE_LABEL: 'Telefon',
    EMAIL_LABEL: 'E-post',

    REJECT: 'Neka',
    ACCEPT: 'Godkänn',


    SELECT_DELIVERY_METHODS: 'Välj leveranssätt',
    ALL_SERVING_METHODS: 'Alla serveringssätt',
    NO: 'Nej',
    YES: 'Ja',
    AND: 'och',
    ORDERS: 'beställningar',
    CHECK_BACK_LATER_FOR_NEW_ORDERS: 'Kolla igen senare för nya beställningar!',
    SELECT_AT_LEAST_ONE_SERVING_METHOD: 'Välj minst ett serveringssätt för att visa dess beställningar.',
    NO_ORDERS_FOUND: 'Inga beställningar hittades för valda metoder.',
    NO_UNITS_FOUND_FOR_THIS_USER: "Inga enheter hittades för denna användare.",
    CONTACT_ADMIN_IF_ERROR: "Kontakta din administratör om du tror att detta är ett fel.",
    LOG_IN: 'Logga in',
    EMAIL: 'E-post',
    PASSWORD: 'Lösenord',
    PLEASE_ENTER_YOUR_DETAILS: 'Vänligen ange dina uppgifter',
    SELECT: 'Välj',
    ORDER_NUMBER: 'Beställning',
    BY: 'Av:',
    TIME: 'Tid:',
    ORDER_INFO: 'Beställningsinfo',
    CUSTOMER_NAME: 'Kundnamn',
    ORDER_DATE: 'Beställningsdatum',
    ORDERED_AT: 'Beställd',
    COMPLETED_AT: 'Klar',
    TABLE: 'Bord',
    LOCATION: 'Plats',
    ORDER_NOTE: 'Notering',
    DELIVERY_NOTE: 'Leveransnotering',
    PAYMENT: 'Betalning',
    RECEIPT_NUMBER: 'Kvitto #',
    METHOD: 'Metod',
    FOOD: 'Mat',
    DRINKS: 'Dryck',
    DELIVERY_FEE: 'Leveransavgift',
    DISCOUNT: 'Rabatt',
    COUPON_DISCOUNT: 'Kupongrabatt',
    BONUS_VOUCHER: 'Bonuscheck',
    TOTAL: 'Totalt',
    REQUEST_REFUND: 'Begär återbetalning',
    PRODUCTS: 'Produkter',
    UNKNOWN: 'Okänd',
    NO_ORDER_SELECTED: 'Ingen beställning vald',
    SELECT_ORDER_FROM_SIDEBAR: 'Välj en beställning i sidofältet för att se detaljer.',

    INCOMING_ORDERS: 'Inkommande beställningar',
    COMPLETED_ORDERS: 'Genomförda beställningar',
    SEARCH_ORDERS: 'Sök beställningar',

    KIOSK_USER: 'Kioskanvändare',
    POS_USER: 'POS',
    NO_INCOMING_ORDERS_TO_SHOW: 'Inga inkommande beställningar att visa',

    PRINT: 'Skriv ut',
    PRINT_RECEIPT: 'Skriv ut kvitto',
    RECEIPT_NOT_FOUND: 'Kvitto hittades inte',
    RECEIPT_PRINT_SUCCESS: 'Kvittot har skickats till skrivaren',
    START_PREPARING: 'Börja förbereda',
    ALL_CAUGHT_UP: 'Allt klart!',

    TOGGLE_DARK_MODE: "Byt mörkt läge",
    SETTINGS: "Inställningar",
    CLOSE: "Stäng",
    WORKING: "Jobbar",
    PRINTERS: "Skrivare",
    NOTIFICATIONS: "Notiser",
    OPEN_CLOSE: "Öppna & stäng appen",
    FOOD_SALES: "Matförsäljning",
    DRINKS_SALES: "Drycksförsäljning",
    MESSAGE_WHEN_TAB_CLOSED: "Meddelande till kund när denna flik är stängd",
    OPEN: "Öppet",
    CLOSED: "Stängt",
    CLOSED_MESSAGE_PLACEHOLDER: "Meddelande vid stängt...",
    SAVE: "Spara",
    SAVED: "Inställningar sparade",
    SOUND_ON_BONG_NOTIFICATION: "Sätt på ljudnotis när ny bong kommer",
    SOUND_UNTIL_TAP: "Spela ljud tills någon trycker på skärmen",
    TEXT_OFF_ON_BONG: "Stäng av textnotis när ny bong kommer",
    HIGHLIGHT_ON_NEW_ORDER: "Ändra bakgrundsfärg när ny bong anländer",
    AVAILABLE_PRINTERS: "Tillgängliga skrivare",
    MAC: "MAC:",
    NO_PRINTERS_FOUND: "Inga tillgängliga skrivare hittades",
    CHECK_PRINTER_SETUP: "Kontrollera din skrivarkonfiguration eller anslutningar och försök igen.",
    CHANGE_UNIT: "Byt enhet",
    LOGOUT: "Logga ut",
    BACK_TO_LOGIN: "Tillbaka till Login",
    DONE: "Klar",
    ITEMS_COMPLETED_HEADER: "Varor klara",
    ITEMS_COMPLETED_DETAIL: "Alla varor i denna beställning har markerats som klara.",
    REJECT_ORDER_CONFIRM_MESSAGE: "Är du säker på att du vill avvisa denna beställning? Denna åtgärd kan inte ångras.",
    REJECT_ORDER_HEADER: "Avvisa beställning",
    REJECTED_ORDER_SUMMARY: "Beställning avvisad",
    REJECTED_ORDER_DETAIL: "Denna beställning har avvisats och kan inte längre behandlas.",
    REJECT_ORDER_ERROR_SUMMARY: "Kunde inte avvisa beställning",
    REJECT_ORDER_ERROR_DETAIL: "Ett fel uppstod när beställningen skulle avvisas. Försök igen.",
    REQUEST_REFUND_CONFIRM_MESSAGE: "Är du säker på att du vill begära återbetalning för denna beställning?",
    REQUEST_REFUND_HEADER: "Begär återbetalning",
    REFUND_REQUESTED_SUMMARY: "Återbetalning begärd",
    REFUND_REQUESTED_DETAIL: "Din begäran om återbetalning har skickats in.",
    REQUEST_REFUND_ERROR_SUMMARY: "Kunde inte begära återbetalning",
    REQUEST_REFUND_ERROR_DETAIL: "Ett fel uppstod när återbetalning skulle begäras. Försök igen.",
    SET_ORDER_COMPLETED_MESSAGE: "Är du säker på att du vill markera denna beställning som klar?",
    SET_ORDER_COMPLETED_HEADER: "Markera beställning som klar",
    COMPLETED_TAG: "Klar",
    ORDER_STATUS_UPDATED: "Beställningsstatus har uppdaterats.",
    GENERAL_ERROR: "Något gick fel. Försök igen.",
    ORDER_SAVE_ROLLBACK_DETAIL: "Ändringarna kunde inte sparas och har återställts.",
    NO_PRINTERS_SELECTED: 'Inga skrivare valda',
    NO_PRINTERS_CONFIGURED: 'Gå till Inställningar -> Skrivare och välj bland tillgängliga skrivare.',
    RESET_PASSWORD: "Återställ lösenord",
    SEARCH: "Sök",
    THIS_WEEK: "Denna vecka",
    UPCOMING_WEEK: "Kommande vecka",
    DAY_LOCKED_TOOLTIP: "Kan endast slutföras på beställningens schemalagda dag",
     WITHOUT: "Utan",
    SOMETHING_WENT_WRONG: "Något gick fel",
    PLEASE_TRY_AGAIN: "Vänligen försök igen",
    INVALID_EMAIL: "Ogiltig e-postadress",
    EMAIL_OR_PASSWORD_NOT_CORRECT: "E-postadress eller lösenord är felaktigt",

    // Coursing
    COURSE_NAME_1: "Förrätt",
    COURSE_NAME_2: "Varmrätt",
    COURSE_NAME_3: "Efterrätt",
    COURSE: "Rätt",
    COURSE_ADDITION: "TILLÄGG",
    HELD_COURSES_TITLE: "Kommande rätter",
    HELD_COURSE_WAITING: "Väntar på servitören",
    HELD_COURSES_HINT: "Visas här tills servitören skickar rätten. Förbered inte än.",
    LOAD_MORE: "Ladda fler",
}
